module.exports = __webpack_public_path__ + "static/media/acercade.d9b9c344.png";